<template>
  <loading v-if="loading" />
  <div class="bannersBox">
    <div class="inner">
      <div class="banner type3" v-if="!member.info.verified">
        <a @click.prevent="$router.replace('/SignUp')"
          ><img src="@/assets/images/banner_account.png"
        /></a>
      </div>

      <div
        class="banner type1"
        v-if="
          member.info.verified === 1 &&
            appointments.length === 0 &&
            todayWaitInfo.length === 0
        "
      >
        <div class="text">
          <div class="inner">
            <div class="t1">
              <span>{{ member.info.name }} 您好!!</span>
            </div>
            <div class="t3" style="margin-left: 9px;">
              <p>您目前尚無其他日期的預約</p>
            </div>
          </div>
        </div>
        <div class="icon">
          <img src="@/assets/images/banner_icon1.svg" />
        </div>
      </div>

      <div class="banner type2" v-for="(w, idx) in todayWaitInfo" :key="idx">
        <p style="color: white; opacity:0.7">
          {{ w.dept }}&nbsp;{{ w.room }}&nbsp;{{ w.dr }}醫師
        </p>
        <div class="box">
          <div class="title">您的號碼</div>
          <div class="number">{{ w.appointmentNo }}</div>
        </div>
        <div class="box">
          <div class="title">目前進度</div>
          <div class="number">{{ w.currentNo }}</div>
        </div>
        <div class="box">
          <div class="title">下一號碼</div>
          <div class="number">{{ w.nextNo }}</div>
        </div>
      </div>

      <div class="banner type1" v-for="(a, idx) in appointments" :key="idx">
        <div class="text">
          <div class="inner">
            <div
              class="t3"
              style="color: white; font-size: 21px; margin-bottom: 8px;"
            >
              {{ a.科別 }} {{ a.醫師名 }} 醫師
            </div>
            <div class="t3">{{ a.日期 }}&nbsp; {{ a.班別 }}診</div>
            <div class="t3">
              <span>{{ a.診別 }}</span
              ><span>{{ a.掛號序號 }}&nbsp;號</span>
            </div>
            <!-- <div v-if="suggestedCheckInTime(a)" style="font-size: 0.73em;">
              建議報到時間 {{ suggestedCheckInTime(a) }}
            </div> -->
          </div>
        </div>
        <div class="icon">
          <img src="@/assets/images/banner_icon1.svg" />
        </div>
      </div>
    </div>
  </div>
  <modal v-if="modal.display" @close="modal.display = false">
    <template v-slot:header v-if="modal.header">{{ modal.header }}</template>
    <template v-slot:body>{{ modal.body }}</template>
  </modal>
  <debug v-if="debug">
    預約:{{ appointments.length }}看診:{{ todayWaitInfo.length }}
  </debug>
</template>

<script>
import api from "../api/index";
export default {
  data() {
    return {
      debug: eval(process.env.VUE_APP_DEBUG),
      loading: false,
      modal: {},
      appointments: [], //預約記錄
      visited: [], //報到紀錄
      waitinfo: [],
      timer: null,
      interval: 3 * 1000
    };
  },
  mounted() {
    console.info("LightBox from member", this.member);
    if (this.member.info.verified === 1) {
      this.getAppointments(); //先查預約記錄,後查報到紀錄(註:方鼎報到後,就查無今日預約記錄)
    }
    //TODO: 查詢最新消息
  },
  computed: {
    member() {
      return this.$store.state.member;
    },
    todayAppointments() {
      //合併預約與報到紀錄
      const appointments = this.appointments.filter(a => a.today === true);
      const visited = this.visited;
      return appointments.concat(visited);
    },
    todayWaitInfo() {
      let myWaitInfo = [];
      this.todayAppointments.forEach(a => {
        if (a === undefined) return; // computed 會有延遲

        const myAppointment = this.waitinfo.filter(w => {
          if (w.dept === a.科別 && w.sec === a.班別 && w.room === a.診別) {
            // console.info(
            //   "比對成功",
            //   `${a.科別}=${w.dept},${a.班別}=${w.sec},${a.診別}=${w.room}`
            // );
            return w;
          } else {
            // console.info(
            //   "比對失敗",
            //   `${a.科別}=${w.dept},${a.班別}=${w.sec},${a.診別}=${w.room}`
            // );
          }
        });
        if (myAppointment.length) {
          //有今天的診
          myWaitInfo.push({
            dept: a.科別,
            sec: a.班別,
            room: a.診別,
            dr: a.醫師名,
            appointmentNo: a.掛號序號,
            currentNo: myAppointment[0].currentNo,
            nextNo: myAppointment[0].nextNo
          });
        }
      });
      return myWaitInfo;
    }
  },
  methods: {
    suggestedCheckInTime(apt) {
      if (apt.診別.indexOf("影像") >= 0) return "請洽院所";
      switch (true) {
        // 婦產科
        case apt.科別 === "婦產科" && apt.班別 === "早" && apt.掛號序號 <= 5:
          return "09:30 前";
        case apt.科別 === "婦產科" && apt.班別 === "早" && apt.掛號序號 <= 20:
          return "10:30 前";
        case apt.科別 === "婦產科" && apt.班別 === "早":
          return "12:00 前";
        case apt.科別 === "婦產科" && apt.班別 === "午" && apt.掛號序號 <= 5:
          return "14:30 前";
        case apt.科別 === "婦產科" && apt.班別 === "午" && apt.掛號序號 <= 20:
          return "15:30 前";
        case apt.科別 === "婦產科" && apt.班別 === "午":
          return "17:00 前";
        case apt.科別 === "婦產科" && apt.班別 === "晚" && apt.掛號序號 <= 5:
          return "19:00 前";
        case apt.科別 === "婦產科" && apt.班別 === "晚" && apt.掛號序號 <= 20:
          return "20:00 前";
        case apt.科別 === "婦產科" && apt.班別 === "晚":
          return "21:30 前";
        // 小兒科
        case apt.科別 === "小兒科" && apt.班別 === "早" && apt.掛號序號 <= 39:
          return "09:00 ~ 10:30";
        case apt.科別 === "小兒科" && apt.班別 === "早":
          return "12:00 前";
        case apt.科別 === "小兒科" && apt.班別 === "午" && apt.掛號序號 <= 39:
          return "14:00 ~ 15:30";
        case apt.科別 === "小兒科" && apt.班別 === "午":
          return "16:30 前";
        case apt.科別 === "小兒科" && apt.班別 === "晚" && apt.掛號序號 <= 39:
          return "18:30 ~ 20:00";
        case apt.科別 === "小兒科" && apt.班別 === "晚":
          return "21:00 前";
        default:
          return "";
      }
    },
    //查詢預約紀錄
    getAppointments() {
      this.loading = true;
      api.appointment
        .query({
          jwt: this.member.jwt
        })
        .then(data => {
          console.info("預約記錄", data);
          this.loading = false;
          this.appointments = data.appointments;
          console.info("今日預約", this.todayAppointments);
          if (this.todayAppointments.length) {
            //已預約,尚未報到
            this.getWaitInfo();
            this.timer = setInterval(this.getWaitInfo, this.interval);
          } else {
            //已報到,查看診清單(報到)
            this.getVisitList();
          }
        })
        .catch(error => {
          this.loading = false;
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    },
    //查詢報到紀錄
    getVisitList() {
      this.loading = true;
      api.visit.liff
        .query({
          jwt: this.member.jwt
        })
        .then(data => {
          console.log("報到清單", data);
          this.loading = false;
          this.visited = data.visited;
          if (this.todayAppointments.length) {
            //已報到
            this.getWaitInfo();
            this.timer = setInterval(this.getWaitInfo, this.interval);
          } else {
            console.log("沒有今日預約或報到", this.todayAppointments);
          }
        })
        .catch(error => {
          this.loading = false;
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    },
    getWaitInfo() {
      api.progress
        .query({
          platform: this.member.platform,
          jwt: this.member.jwt
        })
        .then(data => {
          if (data.code === "success") {
            this.waitinfo = data.progress;
            // console.info("看診進度", this.progress);
            console.info("我的看診", this.todayWaitInfo);
          }
        })
        .catch(error => {
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    }
  },
  beforeUnmount() {
    clearInterval(this.timer);
  }
};
</script>
